import { CommonModule, WeekDay } from '@angular/common';
import { Component, OnInit, Input } from '@angular/core';
import { IDaySalonSchedule, IDaySalonScheduleTimeSlot } from '@app/salon-details/models/day-salon-schedule.model';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-salon-details-opening-hours',
  templateUrl: './opening-hours.component.html',
  styleUrls: ['./opening-hours.component.scss'],
  standalone: true,
  imports: [CommonModule, TranslateModule]
})
export class OpeningHoursComponent implements OnInit {
  @Input() schedule: IDaySalonSchedule[];
  formattedSchedule: IDayFormattedSalonSchedule[] = [];

  constructor() { }

  ngOnInit(): void {
    this.schedule.forEach((day: IDaySalonSchedule) => {
      this.formattedSchedule.push({
        dayNameAbbrev: this.getWeekDayTranslationKey(day.dayOfWeek),
        dayTimeSlots: this.getFormattedDayTimeSlots(day.timeSlots)
      });
    });
  }

  private getWeekDayTranslationKey(weekDay: WeekDay): string {
    return `SHARED.WEEKDAYS-ABBREV.${WeekDay[weekDay].toUpperCase()}`;
  }

  private getFormattedDayTimeSlots(timeSlots: IDaySalonScheduleTimeSlot[]): string[] {
    if (!timeSlots) { return [] }
    const ranges: string[] = [];
    timeSlots.forEach((range: IDaySalonScheduleTimeSlot) => {
      const [startHours, startMinutes] = range.start.split(':');
      const [endHours, endMinutes] = range.end.split(':');
      ranges.push(`${startHours}:${startMinutes} - ${endHours}:${endMinutes}`);
    });
    return ranges;
  }
}

interface IDayFormattedSalonSchedule {
  dayNameAbbrev: string;
  dayTimeSlots: string[];
}
